import { createFileRoute } from '@tanstack/react-router';
import { ContractCreateRoute } from '@/pages/contracts/form-route';
import { parseContractSuccessorPlan } from '@/pages/contracts/lib/contract-routes';
import { contractFormSearchSchema } from '@/routes/-shared/contractsSearchSchema';

export const Route = createFileRoute('/admin/_layout/contracts/_layout/new')({
  component: ContractCreateRouteComponent,
  validateSearch: contractFormSearchSchema,
});

function ContractCreateRouteComponent() {
  const search = Route.useSearch();
  const { mode, sourceId, commercialRequestId } = search;

  return (
    <ContractCreateRoute
      mode={mode}
      sourceId={sourceId ?? undefined}
      commercialRequestId={commercialRequestId ?? undefined}
      successor={parseContractSuccessorPlan(search)}
    />
  );
}
